export enum AppPlatform {
  desktop = 1,
  iOS,
  android
}
